import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { timeFormatDefaultLocale, TimeLocaleDefinition } from "d3-time-format";
import ruTimeFormat from "../assets/timeFormat_ru.json";
import enTimeFormat from "../assets/timeFormat_en.json";

export default () => {
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    timeFormatDefaultLocale((language === "ru" ? ruTimeFormat : enTimeFormat) as TimeLocaleDefinition);
  }, [language]);
};
